export default __webpack_public_path__ + "images/1ae0b0d22f34b5af663aea60bc8c521f.svg";